import { createAction, props } from '@ngrx/store';
import { ICustomerValidate } from '../../../core/models/customer.model';
import { IErrorComponentData } from '../../../core/models/error.model';
import {
  IAppSession,
  IExtraData,
  IFingerPrint,
  ILargeContentConfig,
  IPutRecord,
  ITransactions,
} from '../../../core/models/app.model';

export const getCurrentRoute = createAction(
  '[App] Get Current Route',
  props<{ currentRoute: string }>()
);

export const setCurrentFlow = createAction(
  '[App] Set Current Flow',
  props<{ currentFlow: string }>()
);

export const setNewStep = createAction('[App] Set New Step', props<{ step: number }>());

export const nextStep = createAction('[App] Go to Next Step');

export const stepBack = createAction('[App] Go to Step Back');

export const setIsLargeContentConfig = createAction(
  '[App] Set Config If Content is Larger',
  props<{ largeContentConfig: ILargeContentConfig }>()
);

export const getTransactions = createAction('[App] Get Transactions Information');

export const getTransactionsWithOutId = createAction(
  '[App] Get Transactions Information Without Id'
);

export const setTransactions = createAction(
  '[App] Set Transactions Information',
  props<{ transactions: ITransactions }>()
);
export const setDataFingerPrint = createAction(
  '[App] Set Data Finger Print',
  props<{ data: IFingerPrint }>()
);
export const successDataFingerPrint = createAction('[App] Success Data Finger Print');
export const errorTransactions = createAction('[App] Error Transacions Information');

export const setIsLoading = createAction(
  '[App] Set General Is Loading',
  props<{ isLoading: boolean }>()
);

export const requestLogin = createAction(
  '[App] Request Login',
  props<{ phone: string; code: string }>()
);

export const successRequestLogin = createAction(
  '[App] Success Request Login',
  props<{ session: IAppSession }>()
);

export const failureRequestLogin = createAction(
  '[App] Failure Request Login',
  props<{ error: string }>()
);

// New One
export const requestCustomerValidate = createAction('[App] Request Customer Validate');

export const successRequestCustomerValidate = createAction(
  '[App] Success Request Customer Validate',
  props<{ validation: ICustomerValidate }>()
);

export const failureRequestCustomerValidate = createAction(
  '[App] Failure Request Customer Validate',
  props<{ error: string }>()
);

export const requestCustomerReValidate = createAction(
  '[App] Request Customer Re-Validate',
  props<{ route: string; step: number }>()
);

export const updateCountTimmerOTP = createAction(
  '[App] Update Count Timer OTP',
  props<{ route: string; step: number }>()
);

export const successRequestReCustomerValidate = createAction(
  '[App] Success Request Customer Re-Validate',
  props<{ route: string; step: number }>()
);

export const failureRequestReCustomerValidate = createAction(
  '[App] Failure Request Customer Re-Validate',
  props<{ error: string }>()
);
// New One

export const closeSession = createAction('[App] Close Session');

export const killPurchase = createAction('[App] Kill Purchase', props<{ description: string }>());

export const successKillPurchase = createAction('[App] Success Kill Purchase');

export const failureKillPurchase = createAction(
  '[App] Failure Kill Purchase',
  props<{ error: string }>()
);

export const redirectLoop = createAction('[App] Redirect After 15 seconds');

export const handleMenu = createAction('[App] Handle Menu');

export const closeMenu = createAction('[App] Close Menu');

export const updateModalShow = createAction(
  '[App] Update modal config',
  props<{ modalShow: boolean }>()
);

export const sendPutRecord = createAction(
  '[App] Send Put Record - Analytics Info',
  props<{ data: IPutRecord; extraData?: IExtraData }>()
);
export const succesSendPutRecord = createAction('[App] Success Send Put Record - Analytics Info');

export const killPurchaseWithoutRedirect = createAction(
  '[App] Kill Purchase Without Redirect',
  props<{ error: string; is_customer?: boolean; componentData?: IErrorComponentData }>()
);

export const successKillPurchaseWithoutRedirect = createAction(
  '[App] Success Kill Purchase Without Redirect',
  props<{ error: string; is_customer: boolean; componentData?: IErrorComponentData }>()
);
export const failureKillPurchaseWithoutRedirect = createAction(
  '[App] Failure Kill Purchase Without Redirect'
);
export const setRedirectUrl = createAction(
  '[App] Set Redirect Url',
  props<{
    redirectUrl: string;
    error: string;
    is_customer?: boolean;
    componentData?: IErrorComponentData;
  }>()
);

export const setRedirectUrlSuccessFlow = createAction(
  '[App] Set Redirect Url Success Flow',
  props<{ redirectUrl: string }>()
);

export const cleanAndReditectUrl = createAction(
  '[App] Clean and RedirectUrl',
  props<{ redirectUrl: string }>()
);

export const killTransaction = createAction(
  '[App] Kill Transaction',
  props<{ error: string; componentData?: IErrorComponentData }>()
);
